<template>
  <div>
    <chat-log :messages="messages" :user_id="this.user_id"></chat-log>
    <div class="chat-composer">
      <input
        type="text"
        class="form-control"
        placeholder="Start typing your message..."
        v-model="messageText"
        v-on:keydown.enter="sendMessage"
      />
      <button
        class="btn btn-primary btn-green-pro float-right"
        @click="sendMessage"
      >
        Send
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["user", "user_id", "event_id"],
  data() {
    return {
      messageText: "",
      messages: []
    };
  },
  created() {
    this.interval = setInterval(() => this.fetchMessages(), 1000);
  },
  methods: {
    sendMessage() {
      // this.$emit('messagesent', {
      //     event_id: this.event_id,
      //     message: this.messageText,
      //     user: {
      //         full_name: this.user
      //     }
      // });

      var data = {
        event_id: this.event_id,
        message: this.messageText,
        user: {
        //   id: this.user_id,
        //   full_name: this.user
            id: "1",
            full_name: "Alex del Piero"
        }
      };

      // clearInterval(this.interval);
      this.messages.push(data);
      // Persisit to DB
      this.$http.post("https://r9ryc2wee0.execute-api.us-east-1.amazonaws.com/v1/chat-messages?eventId=" + this.event_id, data).then(response => {
        console.log("***************************************************");
        console.log(response);
        // console.log('message sent');
        this.updateMessages();
      });

      this.messageText = "";
    },
    fetchMessages() {
      this.$http.get("https://r9ryc2wee0.execute-api.us-east-1.amazonaws.com/v1/chat-messages").then(response => {
        this.messages = response.data;
      }).catch(error => console.log(error));
      console.log('***Fetch Messages');

    //   $.getJSON('https://api.ipify.org?format=jsonp&callback=?', function(data) {
    //     var viewerData = data;
    //     console.log("******"+viewerData.ip);
    //   });

    //   this.messages = [
    //         {
    //             "id": 1,
    //             "message": "Hola desde DB",
    //             "status": "1",
    //             "user_id": 1,
    //             "event_id": 1,
    //             "created_at": "2020-04-12 14:58:44",
    //             "updated_at": null,
    //             "sent_at": "14:58",
    //             "user": {
    //                 "id": 1,
    //                 "firstName": "Alex",
    //                 "lastName": "Del Piero",
    //                 "email": "dev@sosadesign.com",
    //                 "email_verified_at": null,
    //                 "created_at": "2020-04-18 19:16:08",
    //                 "updated_at": "2020-04-18 19:16:08",
    //                 "full_name": "Alex Del Piero"
    //             }
    //         },
    //         {
    //             "id": 2,
    //             "message": "Como estan?",
    //             "status": "1",
    //             "user_id": 2,
    //             "event_id": 1,
    //             "created_at": "2020-04-12 14:59:02",
    //             "updated_at": null,
    //             "sent_at": "14:59",
    //             "user": {
    //                 "id": 2,
    //                 "firstName": "Jose",
    //                 "lastName": "Abdala",
    //                 "email": "pepe.abdala@gmail.com",
    //                 "email_verified_at": null,
    //                 "created_at": "2020-04-07 15:05:03",
    //                 "updated_at": "2020-04-07 15:05:03",
    //                 "full_name": "Jose Abdala"
    //             }
    //         }
    //     ]
    },
    updateMessages() {
      this.$http.get("http://localhost:8000/api/chat/update/" + this.event_id).then(response => {
        console.log(response);
        //this.messages = response.data;
        // this.interval = setInterval(() => this.fetchMessages(), 1000);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-composer {
  display: flex;
}
.chat-composer input {
  flex: 1 auto;
}

.chat-composer button {
  border-radius: 0;
}
</style>
